import React, { Component } from "react";

export interface LoadingScreenProps
{
}

interface LoadingScreenState 
{
}

export class LoadingScreen extends Component<LoadingScreenProps, LoadingScreenState>
{
    constructor(props: LoadingScreenProps)
    {
        super(props);

        this.state = {
        };
    }

    public render(): JSX.Element
    {
        return (
            <div className="container">
                <h1>Loading</h1>
            </div>
        );
    }
}